import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

customerSelectorToolbarStyles.searchButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        margin-left: auto;
    `,
}

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        margin-left: 10px;
    `,
}

customerSelectorToolbarStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 10px;
            span{
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF !important;
            }
        `,
    },
}

customerCardStyles.selectButton = { 
    variant: "primary" 
}